var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shouldShowSearchSuggestion ? _c('div', {
    class: _vm.$style.searchSuggestionContainer
  }, _vm._l(_vm.getSuggestedResources, function (resource) {
    return _c('div', {
      key: resource.resourceId,
      class: _vm.$style.searchSuggestionItemContainer,
      on: {
        "click": function click($event) {
          return _vm.goToResource(resource);
        }
      }
    }, [_c('div', {
      class: _vm.$style.searchSuggestionItem
    }, [_c('div', {
      class: _vm.$style.breadcrumbs
    }, [_c('p', {
      staticClass: "overline-text color-gray"
    }, [_vm._v(" Resources "), resource.categoryName ? [_vm._v("> " + _vm._s(resource.categoryName))] : _vm._e(), resource.subcategoryName ? [_vm._v("> " + _vm._s(resource.subcategoryName))] : _vm._e()], 2)]), _c('p', {
      staticClass: "p1 color-primary-blue"
    }, [_vm._v(_vm._s(resource.title))])])]);
  }), 0) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }